module.exports = __webpack_public_path__ + "img/diorAddict4.3c389f23.jpg";